<template>
  <aside class="'ais-Hits-banner'">
    <a
      v-if="link"
      class="ais-Hits-banner-link"
      :href="link.url"
      :target="link.target"
    >
      <img
        class="ais-Hits-banner-image"
        :src="image.urls[0].url"
        :alt="image.title"
      >
    </a>

    <img
      class="ais-Hits-banner-image"
      :src="image.urls[0].url"
      :alt="image.title"
    >
  </aside>
</template>

<script setup>
const props = defineProps({
  link: { type: Object, default: null },
  image: { type: Object, default: null }
})
</script>
